export default "__VITE_PUBLIC_ASSET__8717047f__"